import React from 'react'

import {
  AlignItems,
  Box,
  Color,
  Display,
  FontWeight,
  Icon,
  IconVariant,
  Text,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

type DiscountBadgeProps = {
  text: string
  withCheck?: boolean
}

// 8px is off the Citrus RadiusScale.
const Pill = withCitrusTheme(Box, () => ({
  borderRadius: '8px',
}))

export const DiscountBadge = ({ text, withCheck = false }: DiscountBadgeProps) => (
  <Pill
    display={Display.Flex}
    alignItems={AlignItems.Center}
    gap={1}
    bg={Color.Success_900}
    color={Color.White}
    paddingV={withCheck ? 1 : 0.5}
    paddingH={2}
  >
    {withCheck && <Icon name="tick" size={5} variant={IconVariant.Inherit} aria-hidden />}
    <Text size={withCheck ? 2 : 0} fontWeight={FontWeight.Bold} color={Color.White}>
      {text}
    </Text>
  </Pill>
)
